import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE
// 复用现有 ADMIN_API_KEY 走 X-Admin-Key 内部 admin 通道（与 AIMarketCustomers.jsx 同模式）
const ADMIN_KEY = 'aim-admin-84deadf05b47284331cbf654'
const authHeaders = () => ({ 'X-Admin-Key': ADMIN_KEY })

export default function PaintingVideoProduction() {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [uploading, setUploading] = useState(false)
  const [form, setForm] = useState({ childName: '', painting: null, style: '卡通动画', description: '' })

  useEffect(() => { loadOrders() }, [])

  const loadOrders = async () => {
    setLoading(true)
    try {
      const res = await fetch(`${API}/painting-video/tasks`)
      const data = await res.json()
      if (data.success) {
        setOrders((data.data || []).map(o => ({
          id: o.id,
          childName: o.child_name || o.childName || '未知',
          style: o.style || '卡通动画',
          status: o.status === 'completed' ? '已完成' : o.status === 'processing' ? '制作中' : '待制作',
          thumbnail: o.thumbnail,
          url: o.video_url,
          created_at: o.created_at
        })))
      }
    } catch (err) { console.error('加载失败', err) }
    finally { setLoading(false) }
  }

  const getStatusBadge = (status) => {
    const map = { '已完成': { bg: '#f6ffed', color: '#52c41a' }, '制作中': { bg: '#e6f7ff', color: '#1890ff' }, '待制作': { bg: '#fffbe6', color: '#faad14' }, '已取消': { bg: '#f5f5f5', color: '#999' } }
    const s = map[status] || { bg: '#f5f5f5', color: '#999' }
    return <span style={{ padding: '2px 10px', borderRadius: 10, fontSize: 12, background: s.bg, color: s.color }}>{status}</span>
  }

  const handleFileChange = (e) => { if (e.target.files[0]) setForm({ ...form, painting: e.target.files[0] }) }

  const handleCreate = async () => {
    if (!form.childName || !form.painting) { alert('请填写孩子姓名并上传画作'); return }
    setUploading(true)
    try {
      const formData = new FormData()
      formData.append('file', form.painting)
      formData.append('child_name', form.childName)
      formData.append('style', form.style)
      formData.append('description', form.description)
      const res = await fetch(`${API}/painting-video/tasks`, { method: 'POST', body: formData })
      const data = await res.json()
      if (data.success) {
        // 同时写入统一资产表
        try {
          const childId = data.data?.child_id
          if (childId) {
            await fetch(`${API}/children/${childId}/assets`, {
              method: 'POST', headers: { ...authHeaders(), 'Content-Type': 'application/json' },
              body: JSON.stringify({
                asset_type: 'painting_animation',
                source: 'cms_upload',
                source_id: data.data.id,
                title: form.childName + '的画作动画'
              })
            })
          }
        } catch (e) { console.error('资产写入失败', e) }
        alert('创建成功！')
        setShowModal(false)
        setForm({ childName: '', painting: null, style: '卡通动画', description: '' })
        loadOrders()
      } else { alert(data.error || '创建失败') }
    } catch (err) { alert('创建失败') }
    finally { setUploading(false) }
  }

  if (loading) return <div style={{ padding: 40 }}>加载中...</div>

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
        <div>
          <h2 style={{ fontSize: 20, marginBottom: 4 }}>🎨 画作动画制作</h2>
          <p style={{ color: '#666', fontSize: 13 }}>将孩子的画作变成动态视频</p>
        </div>
        <button onClick={() => setShowModal(true)} style={{ padding: '12px 24px', background: '#722ed1', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>+ 上传画作制作</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        {['卡通动画', '水彩动画', '油画风格', '素描动效'].map(style => (
          <div key={style} style={{ ...card, textAlign: 'center', cursor: 'pointer', border: '2px solid transparent' }} onClick={() => setForm({ ...form, style })}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>🎨</div>
            <div style={{ fontSize: 14, fontWeight: 500 }}>{style}</div>
            <div style={{ fontSize: 11, color: '#999', marginTop: 4 }}>¥99/次</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
        {orders.length === 0 ? (
          <div style={{ ...card, gridColumn: '1/-1', textAlign: 'center', padding: 40, color: '#999' }}>暂无画作动画任务</div>
        ) : orders.map(o => (
          <div key={o.id} style={{ background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
            <div style={{ height: 160, background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {o.thumbnail ? <img src={o.thumbnail} alt={o.childName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: 48 }}>🖼️</span>}
            </div>
            <div style={{ padding: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <span style={{ fontWeight: 500 }}>{o.childName}</span>
                {getStatusBadge(o.status)}
              </div>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>风格: {o.style}</div>
              <div style={{ fontSize: 12, color: '#999' }}>订单号: {o.id}</div>
              <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                {o.status === '已完成' && o.url && <button onClick={() => window.open(o.url, '_blank')} style={{ ...btn, background: '#722ed1', color: '#fff', flex: 1 }}>查看视频</button>}
                {o.status === '制作中' && <button style={{ ...btn, background: '#1890ff', color: '#fff', flex: 1 }}>制作中...</button>}
                {o.status === '待制作' && <button onClick={() => alert('请等待排期制作')} style={{ ...btn, background: '#faad14', color: '#fff', flex: 1 }}>等待中</button>}
              </div>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div style={modalOverlay}>
          <div style={modalContent}>
            <h3 style={{ marginBottom: 20 }}>上传画作制作动画</h3>
            <div style={{ border: '2px dashed #d9d9d9', borderRadius: 8, padding: 40, textAlign: 'center', marginBottom: 20, cursor: 'pointer' }} onClick={() => document.getElementById('paintingInput').click()}>
              {form.painting ? (
                <div><div style={{ fontSize: 48, marginBottom: 8 }}>✅</div><div style={{ color: '#52c41a' }}>已选择: {form.painting.name}</div></div>
              ) : (
                <div><div style={{ fontSize: 48, marginBottom: 8 }}>📤</div><div style={{ color: '#666' }}>点击或拖拽上传画作</div><div style={{ color: '#999', fontSize: 12, marginTop: 8 }}>支持 JPG、PNG 格式</div></div>
              )}
              <input id="paintingInput" type="file" accept="image/*" onChange={handleFileChange} style={{ display: 'none' }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={label}>孩子姓名</label>
              <input value={form.childName} onChange={e => setForm({ ...form, childName: e.target.value })} style={input} placeholder="请输入孩子姓名" />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={label}>动画风格</label>
              <select value={form.style} onChange={e => setForm({ ...form, style: e.target.value })} style={input}>
                {['卡通动画', '水彩动画', '油画风格', '素描动效'].map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={label}>备注说明</label>
              <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} style={{ ...input, height: 60 }} placeholder="请输入备注，如：画作主题、孩子希望的效果" />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
              <button onClick={() => setShowModal(false)} style={{ ...btn, background: '#f5f5f5', color: '#666' }}>取消</button>
              <button onClick={handleCreate} disabled={uploading} style={{ ...btn, background: '#722ed1', color: '#fff' }}>{uploading ? '上传中...' : '创建任务'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const btn = { padding: '8px 16px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }
const label = { display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }
const input = { width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 13, boxSizing: 'border-box' }
const modalOverlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const modalContent = { background: '#fff', borderRadius: 8, padding: 24, width: 500, maxHeight: '80vh', overflow: 'auto' }
